document.addEventListener("DOMContentLoaded", () => {
 const productButterflies = {
  "/products/ember-the-guardian-of-golden-hearts-butterfly-kimono":
    "https://cdn.shopify.com/s/files/1/0769/9346/2574/files/butterfly-3_9a4a7d6a-4970-4a9f-8e15-5b80896dc652.png?v=1783345860",

  "/products/solis-the-bringer-of-new-beginnings-butterfly-kimono":
    "https://cdn.shopify.com/s/files/1/0769/9346/2574/files/butterfly-6.png?v=1783792143",

  "/products/violet-the-guardian-of-gentle-souls-butterfly-kimono":
    "https://cdn.shopify.com/s/files/1/0769/9346/2574/files/butterfly-8.png?v=1783792145",

  "/products/seren-the-weaver-of-fortunate-paths-butterfly-kimono":
    "https://cdn.shopify.com/s/files/1/0769/9346/2574/files/butterfly-5.png?v=1783792147",

  "/products/lunelle-the-keeper-of-forgotten-dreams-butterfly-kimono":
    "https://cdn.shopify.com/s/files/1/0769/9346/2574/files/butterfly-4.png?v=1783792146",

  "/products/fiora-the-keeper-of-endless-wonder-butterfly-kimono":
    "https://cdn.shopify.com/s/files/1/0769/9346/2574/files/butterfly-7.png?v=1783792145",

  "/collections/the-secret-garden": [
    "https://cdn.shopify.com/s/files/1/0769/9346/2574/files/butterfly-7.png?v=1783792145",
    "https://cdn.shopify.com/s/files/1/0769/9346/2574/files/butterfly-5.png?v=1783792147",
    "https://cdn.shopify.com/s/files/1/0769/9346/2574/files/butterfly-4.png?v=1783792146"
  ]
};

  const currentPath = window.location.pathname;
  const spriteSheets = productButterflies[currentPath];

  if (!spriteSheets) return;

  const availableSpriteSheets = Array.isArray(spriteSheets)
    ? spriteSheets
    : [spriteSheets];

  const container = document.createElement("div");
  container.id = "butterfly-burst";
  document.body.appendChild(container);

  const frameSequence = [
    0, 1, 2, 3, 4, 5, 6, 7, 8,
    7, 6, 5, 4, 3, 2, 1
  ];

  const butterflies = [];
  const count = 50;
  const duration = 6500;
  const startTime = performance.now();

  for (let i = 0; i < count; i++) {
    const el = document.createElement("div");
    el.className = "butterfly";

    const randomSprite =
      availableSpriteSheets[
        Math.floor(Math.random() * availableSpriteSheets.length)
      ];

    el.style.backgroundImage = `url("${randomSprite}")`;

    const size = random(46, 96);
    const depth = size / 75;

    el.style.setProperty("--size", `${size}px`);

    if (size < 45) {
      el.style.filter = "blur(0.4px)";
    } else if (size > 95) {
      el.style.filter = "blur(0px)";
    }

    container.appendChild(el);

    butterflies.push({
      el,

      x: random(-140, window.innerWidth + 140),
      y: window.innerHeight + random(40, 340),

      baseXSpeed: random(-0.25, 0.25),
      sidePush: random(-0.35, 0.35),

      riseSpeed: random(1.8, 2.95) * depth,

      size,
      depth,

      phase: random(0, Math.PI * 2),
      phase2: random(0, Math.PI * 2),
      phase3: random(0, Math.PI * 2),

      frameOffset: Math.floor(
        random(0, frameSequence.length)
      ),

      flapSpeed: random(8, 17),

      delay: random(0, 1800),
      opacity: random(0.58, 1),

      glideStrength: random(0.45, 1.25),
      leanStrength: random(7, 18)
    });
  }

  function animate(now) {
    const elapsed = now - startTime;

    butterflies.forEach((b) => {
      const localTime = elapsed - b.delay;

      if (localTime < 0) return;

      const t = localTime / duration;

      if (t > 1.05) {
        b.el.remove();
        return;
      }

      const time = localTime * 0.001;

      const slowDrift =
        Math.sin(time * 0.45 + b.phase2) * 0.45 +
        Math.sin(time * 0.23 + b.phase3) * 0.35;

      const quickFlutter =
        Math.sin(time * 2.8 + b.phase) * 0.25;

      const glide =
        0.65 +
        Math.sin(time * 1.1 + b.phase3) * 0.35;

      b.x +=
        b.baseXSpeed +
        b.sidePush * 0.35 +
        slowDrift +
        quickFlutter;

      b.y -=
        b.riseSpeed * (glide * b.glideStrength) +
        Math.sin(time * 2.2 + b.phase) * 0.16;

      const lean =
        Math.sin(time * 1.7 + b.phase) *
          b.leanStrength +
        Math.sin(time * 0.62 + b.phase2) * 6;

      const bob =
        Math.sin(time * 3.1 + b.phase2) *
        randomish(b.phase, 3, 8);

      const scale =
        b.depth *
        (
          1 +
          Math.sin(time * 2.4 + b.phase) * 0.05
        );

      const fadeIn = Math.min(localTime / 700, 1);

      const fadeOut =
        1 - Math.max((t - 0.7) / 0.3, 0);

      const alpha =
        Math.max(
          0,
          Math.min(fadeIn, fadeOut)
        ) * b.opacity;

      const frameIndex =
        Math.floor(
          time * b.flapSpeed + b.frameOffset
        ) % frameSequence.length;

      const frame = frameSequence[frameIndex];
      const col = frame % 3;
      const row = Math.floor(frame / 3);

      b.el.style.backgroundPosition =
        `${col * 50}% ${row * 50}%`;

      b.el.style.opacity = alpha;

      b.el.style.transform = `
        translate3d(${b.x}px, ${b.y + bob}px, 0)
        rotate(${lean}deg)
        scale(${scale})
      `;
    });

    if (elapsed < duration + 1200) {
      requestAnimationFrame(animate);
    } else {
      container.remove();
    }
  }

  requestAnimationFrame(animate);

  function random(min, max) {
    return Math.random() * (max - min) + min;
  }

  function randomish(seed, min, max) {
    const value =
      Math.sin(seed * 9999) * 0.5 + 0.5;

    return min + value * (max - min);
  }
});